import { useMemo } from 'react';
import { useAuthContext } from '@lp/core/auth';
import { CaseLogTab as SharedCaseLogTab } from '@features/components/CaseOverview/components';
import { prepareLogs } from '@features/components/CaseOverview/components/CaseLogTab';
import { useCaseLogsQuery } from '@/queries/case';
import { Case } from '@/api/apis/case';
import { CaseDetailsPermissions } from '@/permissions';

type CaseLogTabProps = {
  caseInfo: Case;
};

export const CaseLogTab = ({ caseInfo }: CaseLogTabProps) => {
  const { checkPermission } = useAuthContext();
  const hasQuoteTotalsPermission = checkPermission(CaseDetailsPermissions.CaseQuoteRead);
  const { data: logs, isLoading, isFetching } = useCaseLogsQuery(caseInfo.caseId, hasQuoteTotalsPermission);

  const logsOrdered = useMemo(() => prepareLogs(logs), [logs]);

  return <SharedCaseLogTab caseData={caseInfo} logs={logsOrdered} isLoading={isFetching || isLoading} />;
};
